import {authFetch} from "../../authentication/authFetch";

const API_URL = process.env.REACT_APP_API_URL;

async function parseJsonResponse(response) {
    if (response.status === 204) {
        return null;
    }

    const rawBody = await response.text();
    if (!rawBody) {
        return null;
    }

    try {
        return JSON.parse(rawBody);
    } catch {
        throw new Error("Invalid JSON response from settings API");
    }
}

export async function fetchSettings(authToken) {
    if (!authToken) {
        throw new Error('Missing auth token');
    }

    const response = await authFetch(`${API_URL}/api/settings`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${authToken}`,
            'Content-Type': 'application/json',
        },
    });

    if (!response.ok) {
        throw new Error('Failed to fetch settings');
    }

    return parseJsonResponse(response);
}

export async function updateSettings(authToken, settings) {
    if (!authToken) {
        throw new Error('Missing auth token');
    }

    const response = await authFetch(`${API_URL}/api/settings`, {
        method: 'PUT',
        headers: {
            Authorization: `Bearer ${authToken}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(settings),
    });

    if (!response.ok) {
        throw new Error('Failed to save settings');
    }

    return parseJsonResponse(response);
}
